export class WishlistAPI {
  localStorageId: string = 'wishlistId'

  get(wishlistId: string): any {
    return new Promise((resolve, reject) => {
      if (wishlistId === '' || wishlistId === 'undefined') {
        wishlistId = this.getWishlistId()
      }

      if (wishlistId !== '') {
        fetch(process.env.apiHost + '/wishlist/' + wishlistId, {
          method: 'GET',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            } else {
              reject(new Error('failed'))
            }
          })
          .then((data) => {
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        reject(new Error('failed'))
      }
    })
  }

  save(items: any) {
    return new Promise((resolve, reject) => {
      const wishlistId: string = this.getWishlistId()
      if (wishlistId === '') {
        this.create(items)
          .then(() => {
            resolve(true)
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        this.update(wishlistId, items)
          .then(() => {
            resolve(true)
          })
          .catch((error) => {
            reject(error)
          })
      }
    })
  }

  create(items: any) {
    return new Promise((resolve, reject) => {
      fetch(process.env.apiHost + '/wishlist', {
        method: 'PUT',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(items),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.wishlist_key !== '') {
            this.setWishlistId(data.wishlist_key)
            resolve(true)
          } else {
            reject(new Error('failed'))
          }
        })
        .catch((error) => reject(error))
    })
  }

  update(wishlistId: string, items: any) {
    return new Promise((resolve, reject) => {
      fetch(process.env.apiHost + '/wishlist/' + wishlistId, {
        method: 'PUT',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(items),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.wishlist_key === wishlistId) {
            resolve(true)
          } else {
            reject(new Error('failed'))
          }
        })
        .catch((error) => reject(error))
    })
  }

  delete() {
    return new Promise((resolve, reject) => {
      const wishlistId: string = this.getWishlistId()
      if (wishlistId !== '') {
        fetch(process.env.apiHost + '/wishlist/' + wishlistId, {
          method: 'DELETE',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.result === 'wishlist deleted') {
              this.setWishlistId('')
              resolve(true)
            }
          })
      } else {
        reject(new Error('failed'))
      }
    })
  }

  getWishlistId(): string {
    if (
      process.browser &&
      localStorage.getItem(this.localStorageId) !== 'undefined'
    ) {
      return localStorage.getItem(this.localStorageId) || ''
    } else {
      return ''
    }
  }

  setWishlistId(wishlistId: string): boolean {
    if (process.browser) {
      localStorage.setItem(this.localStorageId, wishlistId)
      return localStorage.getItem(this.localStorageId) === wishlistId
    } else {
      return false
    }
  }
}
